import { useEffect, useState } from "react";

import { Pricelist } from "@/root/models/pricelist";
import { PricelistsApi } from "@/api/admin/pricelists";

const usePricelists = () => {
  const [pricelists, setPricelists] = useState<Pricelist[]>([]);
  const [getPricelistsLoading, setGetPricelistsLoading] = useState(false);
  const [getPricelistsError, setGetPricelistsError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        setGetPricelistsLoading(true);
        const pricelists = await PricelistsApi.getPricelists();
        setPricelists(pricelists);
      } catch (e: any) {
        setGetPricelistsError(e.message);
      } finally {
        setGetPricelistsLoading(false);
      }
    })();
  }, []);

  const createPricelist = (pricelist: Pricelist) => {
    setPricelists((prev) => [...prev, pricelist]);
  };

  const deletePricelist = (id: string) => {
    setPricelists((prev) => prev.filter((p) => p.pricelistUUID !== id));
  };

  const editPricelist = (id: string, pricelist: Pricelist) => {
    setPricelists((prev) =>
      prev.map((prevPricelist) => {
        if (prevPricelist.pricelistUUID === id) {
          return pricelist;
        }
        return prevPricelist;
      })
    );
  };

  return {
    pricelists,
    getPricelistsLoading,
    getPricelistsError,
    createPricelist,
    deletePricelist,
    editPricelist,
  };
};

export default usePricelists;
